var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img__container--div"},[_c('img',{attrs:{"src":_vm.page.bigImg == '' ? require('@/assets/templateImg.png'): _vm.page.bigImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }